class CartDrawerCustom extends CartDrawer {
	constructor() {
		super();
		this.initAddItem('.js-add-tree');
		this.initAddItem('.js-add-donation');
	}

	initAddItem(selector) {
		if (this.querySelector(selector) != null) {
			this.querySelector(selector).addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				const config = fetchConfig('javascript');
				const formData = { id: this.querySelector(selector).getAttribute('data-id') };
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				config.body = JSON.stringify({
					...formData,
					sections: this.getSectionsToRender().map((section) => section.id),
					sections_url: window.location.pathname,
				});

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							return;
						}

						this.renderContents(response);
					})
					.catch((e) => {
						console.error(e);
					});
			});
		}
	}

	renderContents(parsedState) {
		this.querySelector('.drawer__inner').classList.contains('is-empty') &&
			this.querySelector('.drawer__inner').classList.remove('is-empty');
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);

			if (!sectionElement) return;
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector,
			);
		});

		if (window.upselleTheme != undefined && window.upselleTheme.initActions) {
			window.upselleTheme.initActions(document.querySelector('.upsell'));
		}

		setTimeout(() => {
			this.querySelector('#CartDrawer-Overlay').addEventListener(
				'click',
				this.close.bind(this),
			);
			this.open();
		});

		this.initAddItem('.js-add-tree');
		this.initAddItem('.js-add-donation');
	}
}

customElements.define('cart-drawer-custom', CartDrawerCustom);
